import { FunctionComponent, ReactNode } from 'react'

import { TeaserStandardHorizontalAPIProps } from '@widgets/TeaserStandardHorizontal'
import ResponsiveImageV2 from '@components/ResponsiveImageV2'
import { ImageRatios } from '@components/ResponsiveImageV2/types'
import { getImageWidths } from '@components/TeaserStandardHorizontal/utils'

export type ImageProps = TeaserStandardHorizontalAPIProps['image'] & {
  children?: ReactNode
  className?: string
  imageSize: number
}

const RATIOS = {
  desktop: '1_1',
  tablet: '1_1',
  mobile: '1_1',
} as const satisfies ImageRatios

const Image: FunctionComponent<ImageProps> = ({
  src,
  alt,
  crops,
  className,
  children,
  imageSize,
}) => {
  return (
    <ResponsiveImageV2
      src={src}
      alt={alt}
      crops={crops}
      ratios={RATIOS}
      widths={getImageWidths(imageSize)}
      className={className}
    >
      {children}
    </ResponsiveImageV2>
  )
}

export default Image
